export const formatExifDate = (date: string | null | undefined, time = false): string | null => {
  if (!date || typeof date !== 'string') return null;

  const formattedDate = new Date(date);

  if (formattedDate.toString() === 'Invalid Date') return null;

  return time ? formattedDate.toLocaleString() : formattedDate.toLocaleDateString();
};
